import React, { useState, useEffect } from 'react';
import OrdenTrabajoEditor from './OrdenTrabajoEditor';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  getAllByParent,
  setPending,
  deleted,
} from '../redux/actions/ordenTrabajoActions';
import { callStatus } from '../utils/constants';
import { Button, Space, Layout, Modal } from 'antd';
import { withRouter } from 'react-router-dom';
import {
  EditFilled,
  DeleteFilled,
  PlusCircleOutlined,
  ExclamationCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';
import MetaTable from './base/MetaTable';
import dayjs from 'dayjs';
import { convertDate } from '../utils/funtions';
import StateIcon from './base/StateIcon';
import CustomCellRender from './base/CustomCellRender';
const { confirm } = Modal;

const { Content, Header, Footer } = Layout;

const SelectedContainer = styled.div`
  flex: 1;
`;

const ActionsContainer = styled.div``;

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 10px;
`;
const OrdenTrabajoList = ({
  location,
  stateData,
  ordenTrabajoEstado,
  inversor,
  dispatch,
  match: {
    params: { id, id2 },
  },
  parent,
}) => {
  const [showEdit, setShowEdit] = useState(false);

  const [rowEdit, setRowEdit] = useState(null);

  const history = useHistory();
  useEffect(() => {
    dispatch(getAllByParent(id2));
    // eslint-disable-next-line
  }, []);

  const handleEdit = (data) => {
    setRowEdit(data);
    setShowEdit(true);
  };

  const handleView = (data) => {
    history.push(
      `/campanas/${id}/actividades/${id2}/ordenes-trabajo/${data.id}`
    );
  };

  const handleDelete = (data) => {
    dispatch(deleted(data.id));
  };

  const handleHideEditor = () => {
    setShowEdit(false);
    setRowEdit(null);
    dispatch(setPending());
  };

  const handleConfirm = (item) => {
    confirm({
      title: 'Esta a punto de eliminar un registro, desea continuar?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Si',
      cancelText: 'No',
      autoFocusButton: 'cancel',
      onOk() {
        handleDelete(item);
      },
      onCancel() {},
    });
  };

  const columns = [
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <SearchOutlined onClick={(e) => handleView(record)} />
          <EditFilled onClick={(e) => handleEdit(record)} />
          <DeleteFilled onClick={(e) => handleConfirm(record)} />
        </Space>
      ),
      width: 120,
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Estado',
      dataIndex: 'estado',
      onFilter: (value, record) => {
        return record.estado_id === value;
      },
      sorter: (a, b) => a.estado?.nombre?.localeCompare(b.estado?.nombre),
      filterMultiple: true,
      filters: ordenTrabajoEstado.list.data.map((value) => {
        value['value'] = value.id;
        value['text'] = value.nombre;
        return value;
      }),
      render: (text) => (
        <>
          <StateIcon value={text?.nombre} />
          <span> {text?.nombre} </span>
        </>
      ),
    },
    {
      width: 100,
      ellipsis: true,
      title: 'Número',
      dataIndex: 'numero',
      render: (text, record) => (
        <span className="hover-bold-link" onClick={() => handleView(record)}>
          {text}
        </span>
      ),
    },
    {
      width: 100,
      ellipsis: true,
      title: 'Fecha',
      dataIndex: 'fecha',
      render: (text) =>
        text ? dayjs(convertDate(text)).format('DD/MM/YYYY') : '',
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Labor',
      dataIndex: 'labor',
      render: (text, record) => record.labor?.nombre,
      sorter: (a, b) => a.labor?.nombre?.localeCompare(b.labor?.nombre),
      search: true,
    },
    {
      ellipsis: true,
      title: 'Contratista',
      dataIndex: 'proveedor_nombre',
      sorter: (a, b) => a.proveedor_nombre?.localeCompare(b.proveedor_nombre),
      search: true,
    },

    {
      width: 150,
      ellipsis: true,
      title: 'Superficie Ha',
      dataIndex: 'superficie',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Precio Superficie $',
      dataIndex: 'precio_superficie',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 120,
      ellipsis: true,
      title: 'Dolar',
      dataIndex: 'dolar',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 120,
      ellipsis: true,
      title: 'Importe U$D',
      dataIndex: 'importe',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      ellipsis: true,
      title: 'Aportante',
      dataIndex: 'inversor',
      render: (text, record) => record.inversor?.nombre,
      onFilter: (value, record) => {
        return record.inversor_id === value;
      },
      sorter: (a, b) => a.inversor?.nombre?.localeCompare(b.inversor?.nombre),
      filterMultiple: true,
      filters: inversor.list.data.map((value) => {
        value['value'] = value.id;
        value['text'] = value.nombre;
        return value;
      }),
    },
  ];
  return (
    <Layout style={{ height: '100%' }}>
      <Header></Header>
      <Content>
        <MetaTable
          dataSource={stateData.list.data}
          dataColumns={columns}
          bordered={false}
          selection={false}
          loading={stateData.list.status === callStatus.LIST_IN_PROCESS}
        />
      </Content>
      <Footer>
        <FooterContainer>
          <SelectedContainer></SelectedContainer>
          <ActionsContainer>
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              size="small"
              onClick={(e) => handleEdit({})}
            >
              Agregar
            </Button>
          </ActionsContainer>
        </FooterContainer>
      </Footer>
      {showEdit ? (
        <OrdenTrabajoEditor
          id={rowEdit.id}
          parentId={id2}
          onCancel={handleHideEditor}
          visible={true}
        />
      ) : (
        false
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => {
  const { ordenTrabajo, ordenTrabajoEstado, inversor, actividad } = state;
  const stateData = ordenTrabajo;
  const parent = actividad;

  return {
    stateData,
    ordenTrabajoEstado,
    inversor,
    parent,
  };
};
export default connect(mapStateToProps)(withRouter(OrdenTrabajoList));
